'use client';
import {AudioPlayerItems} from 'libs/types/audio.types';
import {useAppDispatch, useAppSelector} from 'store/hooks';
import {setInfoTrack, trackSwith} from 'store/slices/player.slices';
import noFoto from "../assets/image/no-photo.png";

export interface IPropsAiduo {
    track: string;
    nameTrack: string;
    description: string;
    cover: string;
}

export const useTooogleTrack = () => {
    const dispatch = useAppDispatch();

    const {isPlay, activeTrackNum} = useAppSelector((store) => store.player);

    /* Включает трек по переданному индексу */
    const trackNumberSwith = (numberTrack: number) => {
        dispatch(trackSwith(numberTrack));
    };

    /* Устанавливает информацию о треке */
    const setTrack = ({media, anons, title}: AudioPlayerItems | undefined) => {
        // @ts-ignore
        dispatch(
            setInfoTrack({
                cover: {
                    url: media.images.i1x1?.url ||
                        media.images.i4x3?.url ||
                        media.images.i16x7?.url ||
                        media.images.i16x9?.url ||
                        noFoto.src,
                    caption: '',
                    copyright: ''
                },
                description: anons,
                nameTrack: title,
                // @ts-ignore
                track: media.audio,
            })
        );
    };

    return {
        isPlay,
        setTrack,
        trackNumberSwith,
        activeTrackNum,
    };
};
